import Raven from 'raven-js';
import Eth from '@blockcatio/tabby-library/lib/services/Eth';
import EthWalletManager from '@blockcatio/tabby-library/lib/services/EthWalletManager';
import browserProvider from '@blockcatio/tabby-library/lib/services/walletProviders/browserProvider';
import externalProvider from '@blockcatio/tabby-library/lib/services/walletProviders/externalProvider';
import ledgerProvider from '@blockcatio/tabby-library/lib/services/walletProviders/ledgerProvider';
import createErrorReporter from '@blockcatio/tabby-library/lib/services/errorReporter';
import DynamicTokenContract from '@blockcatio/tabby-library/lib/services/DynamicTokenContract';
import LocalStorage from '@blockcatio/tabby-library/lib/services/LocalStorage';
import EthGateway from '@blockcatio/tabby-library/lib/services/EthGateway';
import CatToken from '@blockcatio/tabby-library/lib/services/CatToken';
import { walletDefinitions } from '@blockcatio/tabby-library/lib/utilities/walletTypes';
import * as notifications from '@blockcatio/tabby-library/lib/services/notifications';

import fetchGasPrices from './fetchGasPrices';
import { fetchEthCurrencyExchangeRates, fetchCatEthExchangeRate } from './currencyExchangeRate';
import TabbyPayContracts from './TabbyPayContracts';
import TabbyPayRouter from './tabbyPayRouter';
import migrator from './storageMigrate';
import { APP_NAME } from '../constants';

export default (
  config,
  web3Eth,
  givenProvider,
  availableWallets = ['browser', 'ledger', 'external'],
  errorReporter = null,
  storageOverride = null,
) => {
  if (!errorReporter) {
    Raven.config(config.RAVEN_DSN, {
      release: config.TABBY_PAY_VERSION,
      environment: process.env.NODE_ENV,
      serverName: window.location.href,
    }).install();
  }

  const storage = storageOverride || new LocalStorage(window.localStorage);

  const eth = new Eth(web3Eth, storage);

  const localWalletDefinitions = [];
  const walletProviders = {};

  availableWallets.forEach((wallet) => {
    const definition = walletDefinitions.find(def => def.type === wallet);
    if (definition) {
      localWalletDefinitions.push(definition);
    }
    switch (wallet) {
      case 'browser':
        walletProviders[wallet] = browserProvider(givenProvider);
        break;

      case 'external':
        walletProviders[wallet] = externalProvider(config.get('NETWORK_RPC_URL'));
        break;

      case 'ledger':
        walletProviders[wallet] = ledgerProvider(
          config.get('NETWORK_RPC_URL'),
          config.get('CONTRACT_NETWORK_ID'),
        );
        break;

      default:
      // Nothing to do for default.
    }
  });
  const walletManager = new EthWalletManager(localWalletDefinitions, walletProviders);

  const contracts = config.get('CONTRACTS').TabbyPay;

  return {
    eth,
    config,
    tabbyPay: new TabbyPayRouter(contracts.map((contract) => {
      const Contract = TabbyPayContracts[`TabbyPayContractv${contract.id}`];
      return {
        ...contract,
        instance: new Contract(contract, eth),
      };
    })),
    storage,
    migrator,
    notifications,
    catToken: new CatToken(web3Eth, {
      tokenContractAddress: config.get('CONTRACTS').CatToken.address,
      paymentContractAddress: config.get('CONTRACTS').CatPaymentCollector.address,
      appName: APP_NAME,
      etherscanAddressUrl: config.get('ETHERSCAN_ADDRESS_URL'),
    }),
    errorReporter:
      errorReporter ||
      createErrorReporter(Raven, notifications, {
        logging: config.get('LOG_ERRORS'),
        raven: config.get('LOG_ERRORS_SENTRY'),
      }),
    fetchGasPrices,
    fetchEthCurrencyExchangeRates,
    fetchCatEthExchangeRate,
    ethGateway: new EthGateway(walletManager, notifications),
    walletManager,
    dynamicToken: new DynamicTokenContract(web3Eth, {
      appName: APP_NAME,
      etherscanAddressUrl: config.get('ETHERSCAN_ADDRESS_URL'),
    }),
    givenProvider,
  };
};



// WEBPACK FOOTER //
// ./src/services/index.js